import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '@l2u/ui/lib/api.ts';
import { invalidateCompany } from '../lib/invalidateCompany.ts';

export type ReviewPayload = {
  decision: 'approve' | 'reject' | 'reset' | 'na' | 'comment';
  comment?: string;
  reference_document_id?: string;
  reference_upload?: { path: string; name: string };
};

// Owns the per-submission review POST and the cache invalidations every review
// decision needs. Shared by the row layout and the document-review table so the
// decision/invalidation logic lives in exactly one place. `onSuccess` lets the
// caller close its modals after a successful decision.
export function useReviewMutation(
  companyId: string,
  submissionId: string | undefined,
  onSuccess?: () => void,
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ReviewPayload) =>
      adminApi.post(`/api/companies/${companyId}/submissions/${submissionId}/review`, input),
    onSuccess: () => {
      // Covers the submissions list and pending-changes too.
      invalidateCompany(qc, companyId);
      onSuccess?.();
    },
  });
}
